function parseListText(raw) {
  if (Array.isArray(raw)) return raw;
  if (!raw || typeof raw !== "string") return [];
  return raw
    .split("\n")
    .map((ln) => ln.trim().replace(/^•\s*/, ""))
    .filter(Boolean);
}

function parseBodyText(raw) {
  if (Array.isArray(raw)) return raw.map((p) => String(p || "").trim()).filter(Boolean);
  if (!raw || typeof raw !== "string") return [];
  return raw.split("\n\n").map((p) => p.trim()).filter(Boolean);
}

export function buildLegalPagesPayload(legalPages) {
  const lp = legalPages || {};
  const op = lp.operator || {};
  const mapSections = (sections) =>
    (sections || []).map((s, i) => ({
      id: s.id || `legal_${i}`,
      title: String(s.title || "").trim(),
      body: parseBodyText(s.body),
      list: parseListText(s.list),
      sort_order: Number(s.sort_order ?? i * 10),
    }));

  return {
    operator: {
      brand: String(op.brand ?? "AutoPark"),
      companyName: String(op.companyName ?? ""),
      seat: String(op.seat ?? ""),
      registry: String(op.registry ?? ""),
      taxNumber: String(op.taxNumber ?? ""),
      email: String(op.email ?? ""),
      website: String(op.website ?? ""),
      effectiveDate: String(op.effectiveDate ?? ""),
    },
    terms: {
      title: String(lp.terms?.title ?? "Általános Szerződési Feltételek (ÁSZF)"),
      sections: mapSections(lp.terms?.sections),
    },
    privacy: {
      title: String(lp.privacy?.title ?? "Adatvédelmi tájékoztató"),
      sections: mapSections(lp.privacy?.sections),
    },
  };
}

/** Admin szerkesztőhöz — body/list textarea formátum. */
export function sectionToEditor(sec) {
  return {
    ...sec,
    bodyText: Array.isArray(sec.body) ? sec.body.join("\n\n") : String(sec.body || ""),
    listText: Array.isArray(sec.list) ? sec.list.join("\n") : String(sec.list || ""),
  };
}

export function sectionFromEditor(sec) {
  return {
    id: sec.id,
    title: sec.title,
    body: parseBodyText(sec.bodyText),
    list: parseListText(sec.listText),
    sort_order: sec.sort_order,
  };
}
